/* global process */

import multiMiddleware from 'redux-multi';
import thunkMiddleware from 'redux-thunk';

import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger as createLoggerMiddleware } from 'redux-logger';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';

import reducer from './reducer';
import queryableHistory from '../queryableHistory';

import * as form from './form';
import * as scenes from './scenes';

const isDev = process.env.NODE_ENV === 'development';

const configureStore = () => {
  const loggerMiddleware = createLoggerMiddleware({
    collapsed: true, timestamp: false
  });

  const routerMiddleware = createRouterMiddleware(queryableHistory);

  const devMiddleware = isDev
    ? [loggerMiddleware]
    : [];

  const middlewares = applyMiddleware(
    // to execute multiple actions eg: dispatch([action1, action2...])
    multiMiddleware,
    // to execute async dispatch
    thunkMiddleware,
    routerMiddleware,
    ...devMiddleware
  );

  return createStore(reducer(queryableHistory),
    composeWithDevTools(
      middlewares
    )
  );

};

export default configureStore();

export * from './form';
export * from './dataset';
export * from './selectedStats';
export * from './hooks';

export { form, scenes };
